export type ThemePref = 'system' | 'light' | 'dark';

export function applyTheme(pref: ThemePref) {
  const root = document.documentElement;
  if (pref === 'system') root.removeAttribute('data-theme');
  else root.setAttribute('data-theme', pref);
  try {
    localStorage.setItem('aslen.theme', pref);
  } catch {
    /* ignore */
  }
}

export function initialTheme(): ThemePref {
  try {
    const v = localStorage.getItem('aslen.theme');
    if (v === 'light' || v === 'dark' || v === 'system') return v;
  } catch {
    /* ignore */
  }
  return 'system';
}
